<template>
  <div id="item-footer">
    <div id="description-cta">
      <item-description ref="description" id="description"/>
      <cta-button ref="cta" id="cta" />
    </div>

    <item-tab-nav></item-tab-nav>
  </div>
</template>

<script>
import ItemDescription from '@cmp/viewer/item_description.vue';
import CtaButton from '@cmp/viewer/cta/cta_button.vue';
import ItemTabNav from '@cmp/viewer/item_tab_nav.vue';

import { mapState } from 'vuex';

export default {
  components: { ItemDescription, CtaButton, ItemTabNav },
  computed: {
    ...mapState({
      item: state => state.item
    })
  },
}
</script>

<style lang="scss" scoped>
  @import '@/packs/application.scss';

  #item-footer {
    margin: 0 40px;
  }

  #description-cta {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    border-radius: 5px;
    margin-bottom: 1rem;
  }

  #description {
    flex-grow: 2;
    text-align: left;
  }

  #cta {
    margin-left: 10px;
  }

  .cta-component {
    align-self: flex-start;
  }
</style>
